import {
    type GetAllSystemLocalesResponseType,
    type GetAllSystemLocalesRequestType
} from "./type";
import {
    request
} from "../request";

const getAllSystemLocales = async (params: GetAllSystemLocalesRequestType): Promise<GetAllSystemLocalesResponseType> => {
    return await request<GetAllSystemLocalesResponseType>("/systemLocale/getAllSystemLocales", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default getAllSystemLocales;
